"use client";

import { c as _c } from "react/compiler-runtime";
import { ReviewCard } from "@/components/card/review-card";
import { TStaticContent } from "@/types/types";
import Masonry from "react-masonry-css";
type ReviewsContainerProps = {
  reviews: TStaticContent["mockReviews"];
};
export default function ReviewsContainer(t0) {
  const $ = _c(5);
  const {
    reviews
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      default: 3,
      1024: 2,
      640: 1
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== reviews) {
    t2 = reviews.map(_temp);
    $[1] = reviews;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <Masonry breakpointCols={t1} className="flex w-auto gap-4" columnClassName="space-y-4">{t2}</Masonry>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}
function _temp(review, i) {
  return <ReviewCard key={i} review={review} />;
}